import UiCommon from './uiCommon.js'

export class AuthValidate {
    /* 结算校验 */
    static authorityValidate = (controllerEvent)=>{
        UiCommon.mask({});
        // 需要异步校验
        return new Promise((resolve, reject)=>{
          controllerEvent('authorityValidate').then((result)=>{
            UiCommon.deleteMask({async:true});
            resolve(result);
          }).catch((err)=>{
            console.warn(err)
            UiCommon.deleteMask({async:true});
          })
        });
    }
}